module.exports = __webpack_public_path__ + "img/parking-sign-yellow.3d2698b7.svg";